// @flow
export const UPDATE_AUTHENTICATED = 'UPDATE_AUTHENTICATED';
export const GET_ACCOUNT_SUCCESS = 'GET_ACCOUNT_SUCCESS';
export const UPDATE_SESSION = 'UPDATE_SESSION';

const GET_ACCOUNT_ERROR = 'GET_ACCOUNT_ERROR';

import createApiClient from 'src/modules/seek-jobs-api-client';
const api = createApiClient();

const initialState = {
  authenticated: false,
  firstName: '',
  emailAddress: ''
};

export default function reducer(
  state: Object = initialState,
  action: any = {}
) {
  switch (action.type) {
    case UPDATE_AUTHENTICATED:
      const { authenticated } = action.payload;

      return {
        ...state,
        authenticated
      };

    case GET_ACCOUNT_SUCCESS:
      const {
        emailAddress,
        personalDetails,
        emailCorrelationId,
        id: seekerId
      } = action.payload;
      const { firstName } = personalDetails;

      return {
        ...state,
        firstName,
        emailAddress,
        emailCorrelationId,
        seekerId
      };

    case GET_ACCOUNT_ERROR:
      return {
        ...state,
        firstName: '',
        emailAddress: '',
        emailCorrelationId: '',
        seekerId: undefined // eslint-disable-line no-undefined
      };

    case UPDATE_SESSION:
      const { userClientId, sessionId } = action.payload;

      return {
        ...state,
        userClientId,
        sessionId
      };

    default:
      return state;
  }
}

export const updateAuthenticated = ({
  authenticated
}: {
  authenticated: boolean
}) => ({
  type: UPDATE_AUTHENTICATED,
  payload: { authenticated }
});

export const updateSession = ({
  userClientId,
  sessionId
}: {
  userClientId: string,
  sessionId: string
}) => ({
  type: UPDATE_SESSION,
  payload: {
    userClientId,
    sessionId
  }
});

export const getCandidateAccount = () => (dispatch: Function) => {
  return api.candidate
    .account()
    .then(account => {
      dispatch({
        type: GET_ACCOUNT_SUCCESS,
        payload: account
      });
    })
    .catch(error => {
      dispatch({
        type: GET_ACCOUNT_ERROR,
        error: true,
        payload: error
      });
      throw error;
    });
};
